import React from 'react'
import {Link} from 'react-router-dom'
import {getStoredState} from '../launch/store'
import Page from '../page/page'

import './achievements.css'

const Achievements = () => {
    const state = getStoredState()

    if (!state || !state.careerStats) {
        return null
    }

    return (
        <Page className="achievements">
            <h1>Achievements</h1>

            <div className="row">
                <div className="col col-25">
                    <h2>Score</h2>
                </div>
                <div className="col col-75 text-align-right">
                    <h2>{state.careerStats.score.toLocaleString()}</h2>
                </div>
            </div>

            <table>
                <tbody>
                    <tr>
                        <td>Victories</td>
                        <td className="text-align-right">
                            {state.careerStats.victories}
                        </td>
                    </tr>
                    <tr>
                        <td>Losses</td>
                        <td className="text-align-right">
                            {state.careerStats.losses}
                        </td>
                    </tr>
                    <tr>
                        <td>Artifacts Collected</td>
                        <td className="text-align-right">
                            {state.careerStats.artifactsCollected}
                        </td>
                    </tr>
                    <tr>
                        <td>Planets Colonized</td>
                        <td className="text-align-right">
                            {state.careerStats.planetsColonized}
                        </td>
                    </tr>
                    <tr>
                        <td>Planets Conquered</td>
                        <td className="text-align-right">
                            {state.careerStats.planetsConquered}
                        </td>
                    </tr>
                    <tr>
                        <td>Planets Lost</td>
                        <td className="text-align-right">
                            {state.careerStats.planetsLost}
                        </td>
                    </tr>
                    <tr>
                        <td>Ships Built</td>
                        <td className="text-align-right">
                            {state.careerStats.shipsBuilt}
                        </td>
                    </tr>
                    <tr>
                        <td>Ships Destroyed</td>
                        <td className="text-align-right">
                            {state.careerStats.shipsDestroyed}
                        </td>
                    </tr>
                    <tr>
                        <td>Ships Lost</td>
                        <td className="text-align-right">
                            {state.careerStats.shipsLost}
                        </td>
                    </tr>
                </tbody>
            </table>

            <Link className="button-1" to="starbase">
                Back
            </Link>
        </Page>
    )
}

export default Achievements
